import {decorate, inject, injectable} from '@yosmanyga/di'
import {AbstractSecureStorage, SecureStorage} from '@yosmanyga/abstract-secure-storage'
import {Dispatcher} from './Dispatcher'

class CredentialManager {
    private credential: CredentialType | false | undefined

    constructor(
        private secureStorage: SecureStorage,
        private dispatcher: Dispatcher
    ) {
    }

    load = async () => {
        if (typeof this.credential !== 'undefined') {
            return
        }

        const encoded = await this.secureStorage.get('credential')

        if (!encoded) {
            this.credential = false;

            return;
        }

        this.credential = JSON.parse(encoded)
    }

    has = (): boolean => {
        // Not loaded?
        if (typeof this.credential === 'undefined') {
            throw new Error();
        }

        return this.credential !== false
    }

    get = (): CredentialType => {
        return this.credential as CredentialType
    }

    save = async (
        credential: CredentialType
    ) => {
        await this.secureStorage.set('credential', JSON.stringify(credential))
        this.credential = credential

        this.dispatcher.retrieve<(credential: CredentialType) => void>('credential_saved').map(service => service(credential))
    }

    delete = async () => {
        await this.secureStorage.delete('credential')

        await this.load();

        this.dispatcher.retrieve<() => void>('credential_deleted').map(service => service())
    }
}

export type CredentialType = {
    user: string,
    token: string
}

decorate(injectable(), CredentialManager)
decorate(inject(AbstractSecureStorage), CredentialManager, 0)
decorate(inject(Dispatcher), CredentialManager, 1)

export {
    CredentialManager
}
